<template>
    <div>
      <v-dialog v-model="showDialog" max-width="900px">
        <!-- Dialog Card -->
        <v-card>
          <v-card-title class="headline">{{ $t("forms.search_scopus.form_title") }}</v-card-title>
    
          <!-- Form Fields -->
          <v-card-text>
            <v-form @submit.prevent="search">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-2 text--secondary">
                    {{ $t('forms.search_scopus.search_by') }}
                  </div>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-text-field
                    v-model="doi"
                    :label="$t('forms.search_scopus.doi')"
                    outlined
                    clearable
                    hide-details="auto"
                    @keyup.enter="search"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    v-model="title"
                    :label="$t('forms.search_scopus.title')"
                    outlined
                    clearable
                    hide-details="auto"
                    @keyup.enter="search"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    @click="search"
                  >
                  {{ $t('forms.search_scopus.search') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
    
          <!-- Results Table -->
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="searchResults"
              dense
              :loading="loading"
              :loading-text="$t('forms.search_scopus.searching')"
              class="elevation-1"
            >
              <!-- "Use this data" Button -->
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="primary"
                  icon
                  @click="useData(item)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
    
              <template v-slot:no-data>
                No results found.
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDialogImported" max-width="800px">
        <!-- Dialog Card -->
        <v-card>
          <v-card-title class="headline">{{ $t("forms.search_scopus.data_imported") }}</v-card-title>
    
          <!-- Form Fields -->
          <v-card-text>
            <v-row>
              <v-col cols="12">
                {{ $t("forms.search_scopus.data_imported_text") }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="closeInfoDialog()"
            >
              {{ $t('forms.search_scopus.close') }}
            </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "SearchScopusForm",
    data() {
      return {
        showDialog: false, // Controls dialog visibility
        showDialogImported: false,
        doi: "",           // Input DOI
        title: "",         // Input Title
        searchResults: [], // Results from API
        loading: false,    // Loading state
        tableHeaders: [
          { text: this.$t("forms.search_scopus.doi"), value: "doi" },
          { text: this.$t("forms.search_scopus.title"), value: "title" },
          { text: this.$t("forms.search_scopus.authors"), value: "authors_text" },
          { text: this.$t("forms.search_scopus.year"), value: "year" },
          { text: this.$t("forms.search_scopus.import"), value: "actions", sortable: false },
        ],
      };
    },
    methods: {
      openDialog() {
        this.showDialog = true;
      },
      closeInfoDialog() {
        this.showDialogImported = false;
      },
      async search() {
        this.loading = true;
        this.searchResults = [];
        try {
          const response = await axios.get(`${this.$store.state.endpoint}/scopus-search`, {
            params: {
              doi: this.doi,
              title: this.title,
            },
          });
  
          this.searchResults = (response.data.results || []).map(item => {
            return {
              doi: item["doi"] || "N/A",
              title: item["title"] || "N/A",
              abstract: item["abstract"] || "N/A",
              keywords: item["keywords"] || [],
              authors_text: item.authors.join(', ') || "N/A",
              num_authors: item.authors.length,
              eissn: item["eIssn"] || "",
              publication_date: item["cover_date"] || "N/A",
              url: item["url"] || "",
              year: item["cover_date"] ? item["cover_date"].substring(0, 4) : "N/A",
              journal: item["journal"] || "",
              conference: item["conference"] || "",
              page_range: item["page_range"] || "",
              volume: item["volume"] || "",
            };
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          this.loading = false;
        }
      },
      useData(row) {
        // Emit the selected row data to the parent component
        this.$emit("use-data", row);
        this.showDialog = false; // Optionally close the dialog
        this.showDialogImported = true;
      },
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    border-radius: 8px;
  }
  .text-subtitle-2 {
    font-size: 0.9rem;
  }
  </style>
  